export default {
  manage_keyFob: "Key Fob",
  manage_keyFobs: "Key Fobs",
  manage_driver: "Driver",
  manage_keyFobs_search_by_key_fob_number: "Search by Key Fob and Driver"
};
